import { mapActions, mapState, mapGetters } from 'vuex';
import { dbRefs } from '../services/firebase/init';

export default {
  data(){
    return {
      dbRefs
    };
  },
  computed: {
    ...mapState({
      activeDoc: state => state.content.activeDoc,
      activeSubDoc: state => state.content.activeSubDoc,
      files: state => state.content.files
    }),
    ...mapGetters({
      vendorRegFile: 'getVendorRegFile',
      vendorTCFile: 'getVendorTCFile'
    }),
    activeDocExists(){
      return this.activeDoc && Object.keys(this.activeDoc).length > 0;
    },
    activeSubDocExists(){
      return this.activeSubDoc && Object.keys(this.activeSubDoc).length > 0;
    },
    requireFileInput(){
      return !this.activeDocExists;
    }
  },
  methods: {
    ...mapActions(['fetchCollection', 'saveDocument', 'setActiveDoc', 'setActiveSubDoc', 'removeDoc'])
  },
  destroyed(){
    this.setActiveDoc(null);
    this.setActiveSubDoc(null);
  }
};